 <div class="loading-screen">
  <div class="loading-background"></div>
  <div class="loading-content">
    <img class="loading-gif" [src]="'../../../../../assets/images/loading/loading.gif'" alt="loading...">
  </div>
</div>
